<template>
    <div class="grid grid-cols-3 gap-y-5 mt-3 justify-around items-end ">
        <div v-for="(acessorio, id) in acessoriosEquipamentos" :key="id">
            <div class="flex flex-col justify-end items-center justify-items-end">
                <span class="font-semibold text-center">{{ acessorio.item }}</span>
                <div class="flex items-center justify-center w-12 h-12 rounded-md shadow flex-wrap"
                    :class="acessorio.estado" :id="id">
                    <img v-if="acessorio.estado === 'quebrado'" class="w-8 h-8" src="@/assets/quebrado.png"
                        alt="Imagem automovel tombado">
                    <span v-if="acessorio.estado === 'ausente'" class="material-symbols-outlined">remove</span>
                    <span v-if="acessorio.estado === 'bom'" class="material-symbols-outlined">thumb_up</span>
                </div>
                <span class="text-center text-sm">{{ acessorio.estado.charAt(0).toUpperCase() + acessorio.estado.substring(1)  }}</span>
            </div>
        </div>
    </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'AcessorioResumo',
    props: {
        acessoriosEquipamentos: {
            type: Object,
            required: true
        },
    },
});
</script>

<style scoped>
.ausente {
    @apply bg-[#6e5dc633] border-[#917bff] text-[#917bff] ;
}
.text-ausente {
    @apply text-[#917bff] ;
}

.quebrado {
    @apply bg-[#f08f92] border-[#CC0003] ;
}
.text-quebrado {
    @apply text-[#CC0003] ;
}

.bom {
    @apply bg-[#c3f5cd] border-verde-sucesso ;
}
.text-bom {
    @apply text-verde-sucesso ;
}
</style>